module.exports = __webpack_public_path__ + "static/media/pirate-captain.daa0fd39.svg";